import React, { useState } from "react";
import {
  experimentalStyled,
  Container,
  Box,
} from "@mui/material";
import { Outlet } from "react-router-dom";

import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

const SIDEBAR_EXPANDED = 220;
const SIDEBAR_MINIMIZED = 64;
const HEADER_HEIGHT = 64;

/* ===== GRID ROOT ===== */
const LayoutRoot = experimentalStyled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "auto 1fr",
  gridTemplateRows: `${HEADER_HEIGHT}px 1fr`,
  gridTemplateAreas: `
    "sidebar header"
    "sidebar content"
  `,
  height: "100vh",        // 🔑 IMPORTANT
  overflow: "hidden",     // 🔑 PREVENT GRID SCROLL
}));

const SidebarArea = experimentalStyled("div")(({ theme }) => ({
  gridArea: "sidebar",
  height: "100vh",
  overflow: "hidden",     // 🔑 Sidebar itself never scrolls
  transition: theme.transitions.create("width", {
    duration: theme.transitions.duration.standard,
  }),
}));

const HeaderArea = experimentalStyled("div")(({ theme }) => ({
  gridArea: "header",
  position: "sticky",
  top: 0,
  zIndex: theme.zIndex.appBar,
  backgroundColor: "#fff",
}));

const ContentArea = experimentalStyled("div")({
  gridArea: "content",
  overflowY: "auto",      // 🔑 ONLY content scrolls
  backgroundColor: "#f5f5f5",
});

const AppLayout = () => {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  const sidebarWidth = collapsed
    ? SIDEBAR_MINIMIZED
    : SIDEBAR_EXPANDED;

  return (
    <LayoutRoot>
      {/* ===== SIDEBAR ===== */}
      <SidebarArea sx={{ width: sidebarWidth }}>
        <Sidebar
          collapsed={collapsed}
          isMobileSidebarOpen={mobileOpen}
          onSidebarClose={() => setMobileOpen(false)}
        />
      </SidebarArea>

      {/* ===== HEADER ===== */}
      <HeaderArea>
        <Header
          collapsed={collapsed}
          toggleSidebar={() => setCollapsed((p) => !p)}
          toggleMobileSidebar={() => setMobileOpen(true)}
        />
      </HeaderArea>

      {/* ===== CONTENT (SCROLLS) ===== */}
      <ContentArea data-content-scroll>
        <Container maxWidth="xl" sx={{ py: 2 }}>
          <Outlet />
          <Footer />
        </Container>
      </ContentArea>
    </LayoutRoot>
  );
};

export default AppLayout;
